module.exports = __webpack_public_path__ + "static/img/guoyao.322f2931.jpg";